<div class="pspdfkit-container" [ngStyle]="{ height: height }"></div>
